(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-carousel-hp-script-viewport"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const norm = (s) => (s ?? "").toString().trim().toLowerCase();

  // --- Tunable parameters ---
  const ACTIVATION_LINE = 0.35;  // 0 = top, 1 = bottom (moves the switch point)
  const HYSTERESIS = 0.08;       // anti-flutter band (fraction of viewport height)
  const MIN_VISIBLE_RATIO = 0.0; // e.g., 0.4 requires 40% of the block visible to allow switching

  // --- Real selectors ---
  const navItems = Array.from(document.querySelectorAll('.category-carousel--marquee__item[data-id]'));
  const blocks   = Array.from(document.querySelectorAll('.product-list-wrapper[data-item-title]'));
  if (!navItems.length || !blocks.length) return;

  // --- Map: normalized title -> nav item(s) ---
  const idToNav = new Map();
  navItems.forEach(el => {
    const key = norm(el.dataset.id);
    if (!idToNav.has(key)) idToNav.set(key, []);
    idToNav.get(key).push(el);
  });

  // --- Sticky header height (if any) ---
  const HEADER_OFFSET = (() => {
    const sticky = document.querySelector('.header-sticky-wrapper');
    return sticky ? sticky.getBoundingClientRect().height : 0;
  })();

  // --- Find the actual scroll root (container with overflow) ---
  const findScrollRoot = (el) => {
    let node = el.parentElement;
    while (node && node !== document.body) {
      const style = getComputedStyle(node);
      const canScroll = /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX);
      if (canScroll && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return null; // fallback to viewport
  };
  const scrollRoot = findScrollRoot(blocks[0]);

  // --- Keep track of current active block (for hysteresis) ---
  let currentActive = null;

  // --- Decide and activate the best matching block/nav right now ---
  const activateByBest = () => {
    const viewportH = (scrollRoot ? scrollRoot.clientHeight : window.innerHeight);
    // Use a configurable activation line instead of viewport middle
    const line = (viewportH * ACTIVATION_LINE);

    let best = null, bestDist = Infinity, bestVisibleRatio = 0;

    const rootRect = scrollRoot ? scrollRoot.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };

    blocks.forEach(b => {
      const r = b.getBoundingClientRect();

      // Compute center relative to the scroll root
      const topRelToRoot = r.top - (scrollRoot ? rootRect.top : 0);
      const center = topRelToRoot + r.height / 2;

      // Distance to activation line (not to viewport center)
      const dist = Math.abs(center - line);

      // Visible ratio within the root/viewport (accounts for sticky header)
      const visTop = Math.max(r.top, rootRect.top + HEADER_OFFSET);
      const visBot = Math.min(r.bottom, rootRect.bottom);
      const visible = Math.max(0, visBot - visTop);
      const vr = r.height > 0 ? Math.min(1, visible / r.height) : 0;

      if (dist < bestDist) {
        best = b;
        bestDist = dist;
        bestVisibleRatio = vr;
      }
    });

    if (!best) return;

    // Hysteresis: do not switch if current is still inside the band around the line
    if (currentActive && best !== currentActive) {
      const rCurr = currentActive.getBoundingClientRect();
      const currCenter = (rCurr.top - (scrollRoot ? rootRect.top : 0)) + rCurr.height / 2;
      const bandTop = line - HYSTERESIS * viewportH;
      const bandBot = line + HYSTERESIS * viewportH;
      const currInsideBand = currCenter > bandTop && currCenter < bandBot;
      if (currInsideBand) return;
    }

    // Require a minimum visible ratio (optional)
    if (bestVisibleRatio < MIN_VISIBLE_RATIO) return;

    // Activate
    currentActive = best;
    const key = norm(best.dataset.itemTitle);

    blocks.forEach(b => b.classList.toggle('is-active', b === best));
    navItems.forEach(btn => btn.classList.remove('is-active'));
    (idToNav.get(key) || []).forEach(btn => btn.classList.add('is-active'));
  };

  // --- Observe intersection changes and delegate to activateByBest ---
  const observer = new IntersectionObserver(() => {
    activateByBest();
  }, {
    root: scrollRoot || null,
    threshold: [0.2, 0.35, 0.5, 0.75],
    // Keep IO simple; fine-grained control handled inside activateByBest
    rootMargin: `${-(HEADER_OFFSET + 20)}px 0px -35% 0px`
  });

  blocks.forEach(b => observer.observe(b));

  // --- Initial activation (no scroll required) ---
  activateByBest();

  // --- Also react on scroll for smoother updates ---
  (scrollRoot || window).addEventListener('scroll', activateByBest, { passive: true });

  // --- Recompute on resize (e.g., header height or viewport changes) ---
  window.addEventListener('resize', activateByBest, { passive: true });
});
  } catch(e) { console.error(e); }
})();

})();
